import axios from '@util/axios';
import requestManager from "@comp/platformApi/requestManager";
import appHelper from "@util/appHelper";

export default {

    /**
     * @param   Object  data
     * - bizId      String
     * - bizType    String
     * - payWayEnum String  WX_SCAN_CARD | WX_H5 | WX_IOS | WX_ANDROID | IOS_IAP | COIN | BALANCE
     */
    payOrder : function(data) {
        return axios({
            method: 'post',
            url: '/api/v1/order/pay',
            data: data
        });
    },

    /**
     * @param   Object  data
     * - time       Number
     * - timeType   String  DAY | MON | YEAR
     * - payWayEnum String  WX_SCAN_CARD | WX_H5 | WX_IOS | WX_ANDROID | IOS_IAP | COIN | BALANCE
     */
    payVip : function(data) {
        return axios({
            method: 'post',
            url: 'api/v1/order/pay/vip',
            data: data
        });
    },

    recharge : function(data) {
        return axios({
            method: 'post',
            url: 'api/v1/order/pay/account/recharge',
            data: data
        });
    },

    updateOrderStatus : function(data) {
        return axios({
            method: 'post',
            url: 'api/v1/order/pay/updateStatus',
            data: data
        });
    },

    /**
     * @param   {Object}    params  request params:
     * bizId
     * bizType
     */
    isNeedCollectInfo(params, callback) {
        requestManager.request({
            url : 'portal/pay/collect',
            data : params
        }, (error, result) => {

            if(error)
            {
                appHelper.generalAjaxError(error);
                return;
            }

            if(result.errorCode)
            {
                appHelper.showHint(result.msg);
                return;
            }

            callback(result);
        });
    },

    /**
     * @param   {Object}    data
     * bizId
     * bizType
     * payInfo
     */
    submitCollectInfo(data, callback) {
        requestManager.request({
            url : 'portal/pay/collect',
            method : 'post',
            data : data
        }, (error, result) => {

            if(error)
            {
                appHelper.generalAjaxError(error);
                return;
            }

            if(result.errorCode)
            {
                appHelper.showHint(result.msg);
                return;
            }

            callback(result);
        });
    }

};
